import React from 'react';
import {Redirect} from 'react-router-dom';
import AppBar from 'material-ui/AppBar';
import Toolbar from 'material-ui/Toolbar';
import IconButton from 'material-ui/IconButton';

import {COLLAPSED_DRAWER, FIXED_DRAWER} from 'constants/ActionTypes';
import SearchBox from 'components/SearchBox';

class Header extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            searchBox: false,
            searchText: '',
            logout: false,
        };
        this.logout = this.logout.bind(this);
    }
    componentDidMount() {
        let localData = sessionStorage.getItem('userData');
        if(localData){
          this.setState({logout: true});
        }
    }
    logout() {
        console.log("LOgout");
        sessionStorage.setItem('userData','');
        sessionStorage.clear();
        this.setState({logout: !this.state.logout});
    }

    updateSearchText(evt) {
        this.setState({
            searchText: evt.target.value,
        });
    }

    render() {
        
        if (!sessionStorage.getItem('userData')) {
            return ( <Redirect to={'/login'}/> );
        }
        const {onToggleCollapsedNav, drawerType} = this.props;
        const drawerStyle = drawerType.includes(FIXED_DRAWER) ? "d-block d-xl-none" : drawerType.includes(COLLAPSED_DRAWER) ? "d-block" : "d-none";

        return (
            <AppBar className="app-main-header">
                <Toolbar className="app-toolbar" disableGutters={false}>
                    <IconButton className={`jr-menu-icon ${drawerStyle}`} aria-label="Menu"
                                onClick={onToggleCollapsedNav}>
                        <span className="menu-icon"/>
                    </IconButton>

                    <a className="app-logo" href="#/">
                        <img src="http://via.placeholder.com/180x65" alt="Jambo" title="Jambo"/>
                    </a>


                    <SearchBox styleName="d-none d-sm-block" placeholder=""
                               onChange={this.updateSearchText.bind(this)}
                               value={this.state.searchText}/>

                    <button type="button" target="_blank"
                            dense
                            className="text-secondary btn jr-btn-rounded btn-primary btn-rounded"
                            color="secondary"  onClick={this.logout}> Logout</button>

                </Toolbar>
            </AppBar>
        );
    }

}


export default Header;



// WEBPACK FOOTER //
// ./components/Header/index.js